import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import Preview from "./Preview";
import "../style.css";

const PREVIEW_IMAGE =
  "https://cvz0u1pxt3vukc60-75797135591.shopifypreview.com/cdn/shop/files/Group_4_1_1.webp";

const FullPreview = ({ data, type, design, typePage, device }) => {
  const badge = (pos) =>
    type === "badge" && data.position === pos ? (
      <Preview data={data} type={type} design={design} typePage={typePage} device={device} />
    ) : null;

  return (
    <Box
      sx={{
        width: 260,
        mx: "auto",
        border: "1px solid #e0e0e0",
        overflow: "hidden",
      }}
    >
      {/* Image block */}
      <Box sx={{ position: "relative", width: "100%" }}>
        <img
          src={PREVIEW_IMAGE}
          alt="product"
          style={{ width: "100%", display: "block" }}
          loading="lazy"
        />
        {type === "label" && (
          <Box sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}>
            <Preview data={data} type={type} design={design} typePage={typePage} device={device} />
          </Box>
        )}
      </Box>

      {/* Below image / above title */}
      {badge("below_image")}
      {badge("above_title")}

      {/* Info block */}
      <Box sx={{ p: 1 }}>
        {/* Title row */}
        <Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.5}>
          {badge("before_title")}
          <Typography variant="body2" fontWeight={600}>
            Product name
          </Typography>
          {badge("after_title")}
        </Stack>

        {/* Below title / above price */}
        {badge("below_title")}
        {badge("above_price")}

        {/* Price row */}
        <Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.5} sx={{ mt: 0.5 }}>
          {badge("before_price")}
          <Typography variant="body2" color="text.secondary">
            $10 USD
          </Typography>
          {badge("after_price")}
        </Stack>

        {/* Below price */}
        {badge("below_price")}
      </Box>
    </Box>
  );
};

FullPreview.defaultProps = {
  typePage: "collection",
  device: "desktop",
};

FullPreview.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.oneOf(["label", "badge"]).isRequired,
  design: PropTypes.object.isRequired,
  typePage: PropTypes.oneOf(["collection", "product"]),
  device: PropTypes.oneOf(["desktop", "mobile"]),
};

export default FullPreview;
